<template>
  <div class="model-3D relative">
    <div class="btn-main" v-show="equip_data.is_iot_ready&&equip_data.product_type!='2'">
      <div>{{ $t("Data Streaming") }}</div>
      <div
        :class="['btn-showData', !iconStatus && 'runstart']"
        @click="showPenalData()"
      >
        <div class="btn-stop" v-show="iconStatus">
          <img src="@/assets/stop.png" alt="" />
        </div>
        <div class="btn-start" v-show="!iconStatus">
          <img src="@/assets/start.png" alt="" />
        </div>
      </div>
    </div>
    <div class="btn-main" style="right: 32%" v-show="equip_data.product_type!='2'&&router_equip_data.children.length>0">
      <div>{{$t('返回机组')}}</div>
      <div @click="backBtn()" class="btn-stop mt-2">
        <img src="@/assets/backbtn.svg" alt="" />
      </div>
    </div>
    <div class="canvas-container relative">
      <div v-if="is3D"  id="webgl" style="outline: none"></div>
      <img v-if="staticModelImg&&!is3D"  :src="staticModelImg" alt="" 
        style="position: absolute;width:85%;height:90%;top:45%;left:55%;transform:translate(-50%, -50%);">
    </div>
    <MarkOverAll
      :equip_data="equip_data"
      :markeData="markeData"
      :chartlist="chartlist"
      v-if="showPenal"
      :NuJuState="NuJuState"
    ></MarkOverAll>
    <div id="penal"></div>
  </div>
</template>

<script>
import dat from "dat.gui";
import * as THREE from "three";
import { TweenMax } from "gsap";
import GLTFLoader from "three-gltf-loader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import {
  CSS2DObject,
  CSS2DRenderer,
} from "three/examples/jsm/renderers/CSS2DRenderer.js";

import MarkOverAll from "./Marke.vue";
import debounce from "lodash/debounce";
const OrbitControls = require("three-orbitcontrols");

var gui;
let renderer,
  controls,
  scene,
  camera,
  css2DRenderer,
  ambientLight,
  pointLight1,
  pointLight2,
  positions = {
    罗茨泵点: [],
    罗茨泵电机点: [],
    螺杆泵点: [],
    螺杆泵电机点: [],
  };

export default {
  name: "VSD420-O-Model",
  props: [
    "equip_data",
    "markeData",
    "currentState",
    "chartlist",
    "getInstancesDetail",
    "equip_data_info",
    "router_equip_data"
  ],
  data() {
    return {
      iconStatus: true,
      showPenal: false,
      penalList: [],
      modelObjects: [],
      NuJuState: "normal",
      is3D:true, // 是否展示3D图
      staticModelImg:'', //静态模型图片
    };
  },
  watch: {
    currentState: {
      handler(val) {
        this.NuJuState = val;
      },
      deep: true,
    },
    NuJuState: {
      handler(val) {
        this.$emit("update:currentState", val);
      },
      deep: true,
    },
    modelList: {
      handler(newVal, oldVal) {
        if (newVal&&this.is3D) {
          this.init();
        }
      },
      deep: true,
    },
    /* 当机组或单体被切换的时候，模型文件要根据is_model被切换 */ 
    equip_data_info:{
      handler:debounce(function (newVal){ //防抖节流
        this.staticModelImg = ""
        this.is3D = true  //跳转了重置一次
        if(newVal.files){
          for(let key in newVal.files) {
            if(key == "3d"){ //模型
             let info = newVal.files[key].find(item=>item.is_model)
             if(info){
              this.is3D = true
             }
            }else if(key == "image"){ //静态模型图片
             let info = newVal.files[key].find(item=>item.is_model)
             if(info){
              this.is3D = false
              this.staticModelImg = info.url
             }
            }
          }
        }

        //如果显示3D模型那么，需要初始化
        if (this.is3D) {
            this.initModel()
        }
      }, 300), // 300ms 延迟
      deep:true,
      immediate:true
    },
  },
  computed: {
    modelList() {
      let data = [];
      if (
        this.equip_data &&
        this.equip_data.files &&
        this.equip_data.files["3d"].length
      ) {
        data = [this.equip_data.files["3d"][0].url];
      }
      
      // var model = localStorage.getItem('deviceProfileName')
      // return [localStorage.getItem('modelStr')||'']
      return data;
    },
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    }
  },
  components: {
    MarkOverAll,
  },
  mounted() {
    if(this.is3D){ //允许初始化模型
      this.initModel
    }
  },
  methods: {
    /* 初始化模型 */ 
    initModel(){
      this.init();
      window.addEventListener("resize", () => {
        this.init();
      });
    },
    /* 切换机组设备时重新赋值 */ 
    setStaticModelImg(){ //由父组件调取
      this.staticModelImg = ""
    },
    backBtn() {
      this.showPenal = false;
      this.iconStatus = true;
      const element = document.getElementById("webgl");
      if (element) {
          element.innerHTML = "";
      }
      this.clearModel();
      this.$emit("getInstancesDetail");
    },
    /* 切换展示按钮 */
    showPenalData() {
      this.showPenal = !this.showPenal;
      this.iconStatus = !this.iconStatus;
      if(controls){
        controls.autoRotate = !controls.autoRotate;
        controls.enableRotate = !controls.enableRotate;
        if (this.$route.query.index == 3) {
          controls.autoRotate = false;
          controls.enableRotate = false;
        }
  
        if (!controls.autoRotate) {
          this.moveAnimate();
        } else {
          this.setVisibel(false);
        }
      }
    },
    async moveAnimate() {
      await TweenMax.to(camera.position, 2, {
        x: 165,
        y: 84,
        z: 35,
      });
      // camera.position.set(165, 84, 35);
      this.setVisibel(true);
    },
    setVisibel(status) {
      this.penalList.forEach((penal) => {
        penal.visible = status;
      });
      this.modelObjects.forEach((object) => {
        object.visible = status;
      });
    },
    getCameraPostion() {
      alert(JSON.stringify(camera.position));
      /* 120 48 14 */
    },
    createMarker(id, { x, y, z }) {
      let domObject = new CSS2DObject(document.getElementById(id));
      domObject.position.x = x;
      domObject.position.y = y;
      domObject.position.z = z;
      domObject.visible = false;
      return domObject;
    },
    createLine(
      position1 = { x: 0, y: 0, z: 0 },
      position2 = { x: 0, y: 0, z: 0 }
    ) {
      let geometry = new THREE.Geometry();
      let lineMaterial = new THREE.LineBasicMaterial({
        color: "#01E7FF",
      });
      geometry.vertices.push(
        new THREE.Vector3(position1.x, position1.y, position1.z),
        new THREE.Vector3(position2.x, position2.y, position2.z)
      );
      let line = new THREE.Line(geometry, lineMaterial);
      scene.add(line);
    },
    /* 清空模型 */
    clearModel() {
      if (scene && scene.children.length >= 1) {
        scene.children.map((item) => {
          scene.remove(item);
        });
        scene.children = [];
        let domDiv = document.querySelector("#webgl");
        if (domDiv != null) {
          domDiv.innerHTML = "";
        }
        camera = null;
        controls = null;
        scene = null;
        renderer.dispose();
        renderer = null;
      }
    },
    init() {
      let domDiv = document.querySelector("#webgl");
      if(domDiv){
        document.querySelector("#webgl").innerHTML = "";
      }
      this.clearModel();
      this.$nextTick(() => {
        /* 场景 */
        scene = new THREE.Scene();
        scene.scale.set(0.6, 0.6, 0.6);

        /* 相机设置 */
        camera = new THREE.PerspectiveCamera(
          75,
          window.innerWidth / window.innerHeight,
          1,
          2000
        );
        // camera.position.set(122, 34, 32);
        camera.position.set(165, 84, 35);

        camera.lookAt(new THREE.Vector3(0, 0, 0));
        /* 模型加载 */
        var loader = new GLTFLoader();
        var dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath("three/examples/jsm/libs/draco/gltf");
        dracoLoader.setDecoderConfig({ type: "js" });
        dracoLoader.preload();
        loader.setDRACOLoader(dracoLoader);

        this.modelList.map((item) => {
          loader.load(item, (gltf) => {
            let model = gltf.scene;
            model.position.y += 30;
            gltf.scene.traverse((object) => {
              if (object.isMesh) {
                object.material.emissiveMap = object.material.map;
              }

              if (positions[object.name]) {
                positions[object.name] = object.position;
              }
              if (object.name == "干泵-罗茨泵") {
                // this.createLine(positions["罗茨泵点"], object.position);
                let marke_lcb = this.createMarker(
                  "marke-lcb",
                  positions["罗茨泵点"]
                );
                this.penalList.push(marke_lcb);
                scene.add(marke_lcb);
              }
              if (object.name == "干泵-罗茨泵电机") {
                // this.createLine(positions["罗茨泵电机点"], object.position);
                let marke_lcbdj = this.createMarker(
                  "marke-lcbdj",
                  positions["罗茨泵电机点"]
                );
                this.penalList.push(marke_lcbdj);
                scene.add(marke_lcbdj);
              }
              if (object.name == "干泵-罗杆泵") {
                // this.createLine(positions["螺杆泵点"], object.position);
                let marke_lgb = this.createMarker(
                  "marke-lgb",
                  positions["螺杆泵点"]
                );
                this.penalList.push(marke_lgb);
                scene.add(marke_lgb);
              }
              if (object.name == "干泵-罗杆泵电机") {
                // this.createLine(positions["螺杆泵电机点"], object.position);
                let marke_lgbdj = this.createMarker(
                  "marke-lgbdj",
                  positions["螺杆泵电机点"]
                );
                this.penalList.push(marke_lgbdj);
                scene.add(marke_lgbdj);
              }
              if (object.name.includes("上线")) {
                object.visible = false;
                this.modelObjects.push(object);
              }
            });
            mixer = new THREE.AnimationMixer(gltf.scene);

            if (gltf.animations.length) {
              let animationAction = mixer.clipAction(gltf.animations[0]).play();
              animationActions.push(animationAction);
            }

            scene.add(model);
          });
        });

        /* css渲染器 */
        css2DRenderer = new CSS2DRenderer();
        css2DRenderer.setSize(
          document.querySelector("#webgl").offsetWidth,
          document.querySelector("#webgl").offsetHeight
        );
        css2DRenderer.domElement.style.position = "absolute";
        css2DRenderer.domElement.style.top = "0";
        document.getElementById("penal").appendChild(css2DRenderer.domElement);

        /* 渲染器 */
        renderer = new THREE.WebGLRenderer({
          alpha: true,
          antialias: true,
          precision: "mediump",
          // logarithmicDepthBuffer:true
        });
        this.$nextTick(() => {
          renderer.setSize(
            document.querySelector("#webgl").offsetWidth,
            document.querySelector("#webgl").offsetHeight
          );
        });
        renderer.setClearColor(0xffffff, 0);
        renderer.setPixelRatio(window.devicePixelRatio);
        document.getElementById("webgl").appendChild(renderer.domElement);
        let clock = new THREE.Clock();

        let mesh;
        let mixer = new THREE.AnimationMixer(mesh);
        let animationActions = [];

        //控制器
        controls = new OrbitControls(
          camera,
          document.getElementById("webgl"),
          renderer.domElement
        );
        /* 缩放 */
        controls.enableZoom = false;
        controls.enablePan = false;
        /* 旋转 */
        if (this.$route.query.index == 3) {
          scene.rotation.y = 1;
          controls.autoRotate = !this.iconStatus;
          controls.enableRotate = !this.iconStatus;
        } else {
          controls.enableRotate = this.iconStatus;
          controls.autoRotate = this.iconStatus;
          controls.autoRotateSpeed = 1;
          /* 阻尼系数 */
          controls.enableDamping = this.iconStatus;
          controls.dampingFactor = 0.1;
          //限制垂直方向的旋转
          controls.minPolarAngle = Math.PI * 0.38;
          controls.maxPolarAngle = Math.PI * 0.38;
        }
        //light
        this.setLight();

        const animate = () => {
          controls.update();
          var delta = clock.getDelta();
          if (mixer != null) {
            mixer.update(delta);
          }

          renderer.render(scene, camera);

          if (gui) {
            pointLight1.position.x = gui.PlightX_4;
            pointLight1.position.y = gui.PlightY_4;
            pointLight1.position.z = gui.PlightZ_4;

            pointLight2.position.x = gui.PlightX_5;
            pointLight2.position.y = gui.PlightY_5;
            pointLight2.position.z = gui.PlightZ_5;
          }
          css2DRenderer.render(scene, camera);

          requestAnimationFrame(animate);
        };

        animate();
      });
    },
    /* 全景灯光 */
    setLight() {
      ambientLight = new THREE.AmbientLight(0xffffff, 1);
      ambientLight.position.set(0, 100, 0);

      pointLight1 = new THREE.PointLight(0xffffff, 0.8);
      pointLight1.position.set(-2616, 1719, 1502);

      pointLight2 = new THREE.PointLight(0xffffff, 0.8);
      pointLight2.position.set(202, 202, -232);

      //   var helper1 = new THREE.PointLightHelper(pointLight1, 100);
      //   var helper5 = new THREE.PointLightHelper(pointLight2, 100);

      //  scene.add(helper1, helper5);

      scene.add(ambientLight, pointLight1, pointLight2);
    },
    initGui() {
      //声明一个保存需求修改的相关数据的对象
      gui = {
        PlightX_4: -2616,
        PlightY_4: 1719,
        PlightZ_4: 1502,
        PlightX_5: 202,
        PlightY_5: 202,
        PlightZ_5: -232,
      };
      var datGui = new dat.GUI();
      //将设置属性添加到gui当中，gui.add(对象，属性，最小值，最大值）
      datGui.add(gui, "PlightX_4", -10000, 10000);
      datGui.add(gui, "PlightY_4", -10000, 10000);
      datGui.add(gui, "PlightZ_4", -10000, 10000);

      datGui.add(gui, "PlightX_5", -10000, 10000);
      datGui.add(gui, "PlightY_5", -10000, 10000);
      datGui.add(gui, "PlightZ_5", -10000, 10000);
    },
  },
  beforeUnmount() {
    if (!this.is3D) {
      return;
    }
    scene.traverse((child) => {
      if (child.material) {
        child.material.dispose();
      }
      if (child.geometry) {
        child.geometry.dispose();
      }
      child = null;
    });
    renderer.forceContextLoss();
    renderer.dispose();
    scene.clear();
    scene = null;
    camera = null;
    controls = null;
    renderer.domElement = null;
    renderer = null;
  },
};
</script>
<style scoped lang="scss">
.model-3D {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .canvas-container {
    width: 100%;
    height: 100%;
    z-index: 1;
    #webgl {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  .controls {
    position: absolute;
    top: 0%;
    left: 50%;
    z-index: 999;
  }
  .btn-main {
    position: absolute;
    top: 0%;
    right: 25%;
    z-index: 2000;//9999
    display: flex;
    flex-flow: column;
    align-items: center;
    font-size: 16px;
    .btn-showData {
      margin-top: 5px;
      border: 3px solid #00e7ff;
      filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
      border-radius: 30px;
      padding: 5px 8px;
      display: flex;
      align-items: center;
      width: 82px;
      &:hover {
        cursor: pointer;
      }
      .btn-stop {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        background: #02364b;
        border-radius: 50%;
        padding: 6px;
        margin-right: 20px;
      }
      .btn-start {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        background: #02364b;
        border-radius: 50%;
        padding: 6px;
      }
      &.runstart {
        justify-content: flex-end;
        background: #00e7ff;
      }
    }
  }

  #penal {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
